
/* eslint-disable */
import { fillConfig } from '@tencent/magic-ui-util/fillConfig'
import { toHump } from '@tencent/magic-ui-util'
import { cloneLoop } from '@/shared/jsmini-clone/index'

import { config as app } from '../../packages/app'
import { config as page } from '../../packages/page'
import { config as container } from '../../packages/container'
import { config as pcContainer } from '../../packages/pc-container'
import { config as pop } from '../../packages/pop'
import { config as tabs, tabPaneConfig as tabPane, tabNavConfig as tabNav } from '../../packages/tabs'
import { config as text } from '../../packages/text'
import { config as link } from '../../packages/link'
import { config as image } from '../../packages/image'
import { config as qrCode } from '../../packages/qrcode'
import { config as video } from '../../packages/video'
import { config as actionButton } from '../../packages/button'

import report from './common/report'
import rect from './common/rect'
import background from './common/background'
import font from './common/font'
import disabledBackground from './common/disabledBackground'
import script from './common/script'
import handler from './common/handler'
import buttonStatus from './common/buttonStatus'
import buttonConfig from './common/buttonConfig';
import magicButtonStatus from './common/magicButtonStatus'
import devConfig from './common/devConfig'
import shareConfig from './common/shareConfig'

import event from './common/event'
import advanced from './common/advanced'

export default {
  pluginMap: {},

  props: {
    app: [...app],
    page: [...page],
    container: [...container],
    pcContainer: [...pcContainer],
    pop: [...pop],
    tabs: [...tabs],
    tabPane: [...tabPane],
    tabNav: [...tabNav],
    text: [...text],
    link: [...link],
    image: [...image],
    qrCode: [...qrCode],
    video: [...video],
    actionButton: [...actionButton],
  },

  cache: {},

  formsConfig: [
    { c_id: 'background', c_type: 'component', c_config: background },
    { c_id: 'disabledBackground', c_type: 'component', c_config: disabledBackground },
    { c_id: 'font', c_type: 'component', c_config: font },
    { c_id: 'report', c_type: 'component', c_config: report },
    { c_id: 'rect', c_type: 'component', c_config: rect },
    { c_id: 'script', c_type: 'component', c_config: script },
    { c_id: 'handler', c_type: 'component', c_config: handler },
    { c_id: 'buttonStatus', c_type: 'component', c_config: buttonStatus },
    { c_id: 'buttonConfig', c_type: 'component', c_config: buttonConfig },
    { c_id: 'magicButtonStatus', c_type: 'component', c_config: magicButtonStatus },
    { c_id: 'devConfig', c_type: 'component', c_config: devConfig },
    { c_id: 'shareConfig', c_type: 'component', c_config: shareConfig }
  ],

  getProp(type = 'text') {
    let prop = this.props[toHump(type)]
    if (typeof prop === 'function') {
      return prop()
    }
    return prop
  },

  getConfig(type = 'text', data, { enabledPlugins, autoFillTab = true } = {}) {
    console.log('[ui] getConfig', type, data);
    const cacheKey = this.createCacheKey(type, enabledPlugins);

    let config = this.cache[cacheKey];
    if (config && config.length) {
      return config;
    }

    config = this.initializeConfig(type);
    if (!config.length) {
      return [];
    }

    config = this.processConfig(config, autoFillTab, data, enabledPlugins, type);
    this.cache[cacheKey] = config;

    return config;
  },

  createCacheKey(type, enabledPlugins) {
    return `type=${type}&plugins=${enabledPlugins.join('_')}`;
  },

  initializeConfig(type) {
    let config = cloneLoop(this.getProp(type));
    if (!Array.isArray(config)) {
      config = [config];
    }
    return config;
  },

  processConfig(conf, autoFillTab, data, enabledPlugins, type) {
    let config = fillConfig(conf, this.formsConfig);

    if (autoFillTab) {
      config = this.autoFillTabConfig(config, data);
      config = this.handlePlugins(config, type, enabledPlugins);
    }

    return config;
  },

  autoFillTabConfig(conf, data) {
    let config = conf;
    if (config[0].type !== 'tab') {
      config = [{
        type: 'tab',
        active: '0',
        items: !config[0].title ? [{
          title: '属性',
          labelWidth: '100px',
          items: config
        }] : config
      }];
    }

    this.updateEventTab(config, data);
    return config;
  },

  updateEventTab(config, data) {
    const eventTab = config[0].items.find(tab => tab.title === '事件');
    if (eventTab && eventTab.items?.[0]?.items?.[0]?.columns?.[0]?.cid) {
      eventTab.items[0].items[0].columns[0].cid = data.id;
    } else if (data.type !== 'app') {
      config[0].items.push(fillConfig(event(data.id), this.formsConfig)[0]);
    }

    if (data.renderType === 1) {
      config[0].items.push(fillConfig(advanced(data), this.formsConfig)[0]);
    }
  },

  handlePlugins(conf, type, enabledPlugins) {
    let config = conf;
    if (enabledPlugins) {
      const pluginList = this.getPluginList(enabledPlugins);
      const formConfigs = this.getFormConfigsFromPlugins(pluginList, type, config);
      if (formConfigs.length) {
        config[0].items.push({
          title: '插件扩展',
          type: 'tab',
          items: formConfigs
        });
      }
      config = this.applyPluginFormConfig(pluginList, type, config);
    }
    return config;
  },

  getPluginList(enabledPlugins) {
    return enabledPlugins.map(packageName => {
      const temp = packageName.split('@');
      const name = `@${temp[1]}`;
      return this.pluginMap[name];
    }).filter(p => p);
  },

  getFormConfigsFromPlugins(pluginList, type, config) {
    return pluginList.map(p => p?.generateFormConfig?.(type, cloneLoop(config))).filter(f => f);
  },

  applyPluginFormConfig(pluginList, type, config) {
    return pluginList.reduce((lastValue, plugin) => {
      const newFormConfig = plugin?.processFormConfig?.(type, lastValue);
      return newFormConfig || lastValue;
    }, config);
  }
}
